module.exports = __webpack_public_path__ + "img/12.d4e0788c.jpg";